
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class DimIndexesGrid extends Serenity.EntityGrid<DimIndexesRow, any> {
        protected getColumnsKey() { return DimIndexesColumns.columnsKey; }
        protected getDialogType() { return DimIndexesDialog; }
        protected getIdProperty() { return DimIndexesRow.idProperty; }
        protected getInsertPermission() { return DimIndexesRow.insertPermission; }
        protected getLocalTextPrefix() { return DimIndexesRow.localTextPrefix; }
        protected getService() { return DimIndexesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}